import { OrderStatusItem } from "./types";
import type { SectionIconEntry } from "../shared/constants";

export { LANGUAGE_CODES } from "../shared/constants";
export type { SectionIconEntry } from "../shared/constants";

// ─── Default section titles (multilingual) ─────────────
export const DEFAULT_SECTION_TITLES: Record<string, string> = {
    fr: "Ma commande",
    en: "My order",
    ru: "\u041C\u043E\u0439 \u0437\u0430\u043A\u0430\u0437",
    it: "Il mio ordine",
    es: "Mi pedido",
    pt: "Minha encomenda",
    de: "Meine Bestellung",
    ar: "\u0637\u0644\u0628\u064A",
};

// ─── Section icons (SVG paths) — MaCommande-specific (order-context) ────
export const SECTION_ICONS: SectionIconEntry[] = [
    {
        key: "cart",
        labelKey: "Cart",
        path:
            "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z",
    },
    {
        key: "receipt",
        labelKey: "Receipt",
        path:
            "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
    },
    {
        key: "restaurant",
        labelKey: "Restaurant",
        path:
            "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z",
    },
    {
        key: "list",
        labelKey: "List",
        path:
            "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z",
    },
    {
        key: "check",
        labelKey: "Check",
        path:
            "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
    },
    {
        key: "timer",
        labelKey: "Timer",
        path:
            "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z",
    },
    {
        key: "payment",
        labelKey: "Payment",
        path:
            "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
    },
    {
        key: "star",
        labelKey: "Star",
        path:
            "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
    },
];

// ─── Default order statuses ────────────────────────────
export const DEFAULT_ORDER_STATUSES: OrderStatusItem[] = [
    { key: "ordered", active: true },
    { key: "preparing", active: true },
    { key: "ready", active: false },
    { key: "served", active: false },
];

// ─── Status labels (multilingual) ──────────────────────
export const STATUS_LABELS: Record<string, Record<string, string>> = {
    ordered: {
        fr: "Commandé",
        en: "Ordered",
        es: "Pedido",
        it: "Ordinato",
        pt: "Encomendado",
        de: "Bestellt",
        ru: "Заказано",
        ar: "تم الطلب",
    },
    preparing: {
        fr: "En préparation",
        en: "In preparation",
        es: "En preparación",
        it: "In preparazione",
        pt: "Em preparação",
        de: "In Vorbereitung",
        ru: "Готовится",
        ar: "قيد التحضير",
    },
    ready: {
        fr: "Prêt",
        en: "Ready",
        es: "Listo",
        it: "Pronto",
        pt: "Pronto",
        de: "Fertig",
        ru: "Готово",
        ar: "جاهز",
    },
    served: {
        fr: "Servi",
        en: "Served",
        es: "Servido",
        it: "Servito",
        pt: "Servido",
        de: "Serviert",
        ru: "Подано",
        ar: "تم التقديم",
    },
};
